import InvestmentAmountCard from "./InvestmentAmountCard";

export default InvestmentAmountCard;
